// components/Tests.jsx
import React from 'react';

const testData = [
  { name: 'Complete Blood Count (CBC)', category: 'Haematology', sample: 'Blood (EDTA)', time: 'Same Day' },
  { name: 'Blood Glucose – Fasting / PP', category: 'Biochemistry', sample: 'Blood (Fluoride)', time: '2–3 Hours' },
  { name: 'HbA1c (Glycated Haemoglobin)', category: 'Endocrinology', sample: 'Blood (EDTA)', time: 'Same Day' },
  { name: 'Liver Function Test (LFT)', category: 'Biochemistry', sample: 'Blood (Serum)', time: 'Same Day' },
  { name: 'Kidney Function Test (KFT)', category: 'Biochemistry', sample: 'Blood (Serum)', time: 'Same Day' },
  { name: 'Thyroid Profile (T3/T4/TSH)', category: 'Endocrinology', sample: 'Blood (Serum)', time: '24 Hours' },
  { name: 'Lipid Profile', category: 'Biochemistry', sample: 'Blood (Serum)', time: 'Same Day' },
  { name: 'Urine Routine & Microscopy', category: 'Urinalysis', sample: 'Mid-Stream Urine', time: '2–3 Hours' },
  { name: 'Vitamin D (25-OH)', category: 'Biochemistry', sample: 'Blood (Serum)', time: '24–48 Hours' },
  { name: 'Dengue NS1 / IgM / IgG', category: 'Serology', sample: 'Blood (Serum)', time: '4–6 Hours' }
];

const Tests = () => {
  return (
    <section id="tests" className="py-20 px-8 bg-white">
      <div className="max-w-[1200px] mx-auto">
        <p className="text-teal text-[0.75rem] font-semibold tracking-[2px] uppercase mb-3">Test Menu</p>
        <h2 className="text-4xl md:text-5xl text-charcoal font-serif mb-4">Commonly Performed Tests</h2>
        <p className="text-[#5a7a77] max-w-md leading-relaxed">A snapshot of our most frequently ordered tests. Contact us for the full test menu and pricing.</p>

        <div className="mt-12 border border-[#e0eeec] rounded-2xl overflow-hidden">
          <table className="w-full border-collapse">
            <thead className="bg-teal">
              <tr>
                <th className="text-white text-xs font-semibold tracking-wider uppercase p-4 text-left">Test Name</th>
                <th className="text-white text-xs font-semibold tracking-wider uppercase p-4 text-left">Category</th>
                <th className="text-white text-xs font-semibold tracking-wider uppercase p-4 text-left">Sample Type</th>
                <th className="text-white text-xs font-semibold tracking-wider uppercase p-4 text-left">Report Time</th>
              </tr>
            </thead>
            <tbody>
              {testData.map((test, idx) => (
                <tr key={idx} className={idx % 2 === 0 ? 'bg-white' : 'bg-[#fafcfb]'}>
                  <td className="p-4 text-sm font-semibold text-charcoal">
                    <span className="inline-block w-2 h-2 bg-[#2ebd95] rounded-full mr-1.5"></span>
                    {test.name}
                  </td>
                  <td className="p-4 text-sm">{test.category}</td>
                  <td className="p-4 text-sm">{test.sample}</td>
                  <td className="p-4 text-sm text-[#7a9490]">{test.time}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="mt-5 text-sm text-[#7a9490] text-center">This is a partial list. Contact us for the complete test menu, specialized panels, and packages.</p>
      </div>
    </section>
  );
};

export default Tests;